import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, watch, withDefaults } from 'vue';
import DateBox from '@/components/DateBox.vue';
import { confirm } from '@/utility/messages';
import { toDate } from '@/utility/date';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectDate',
  props: {
    modelValue: null,
    edited: { type: Boolean },
    dataName: { default: 'データ' },
    disabled: { type: Boolean },
    minDate: null,
    maxDate: null
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: unknown): void;
  (e: 'change'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: unknown, edited: boolean, dataName: string, disabled?: boolean, minDate?: Date, maxDate?: Date }




const model = computed({
  get: () => props.modelValue as Date,
  set: value => emit('update:modelValue', value),
});
watch(() => [props.modelValue], setComponentModel);
function setComponentModel() {
  date.value = model.value as Date;
}

const date = ref(new Date());
const eventTs = ref(0);
const regex = /(\d{4})[年/-](\d{1,2})[月/-](\d{1,2})日?/;

async function changeDate(event: Event, editedMovement: boolean, preDate: Date) {
  if (!(event.target instanceof HTMLInputElement) || event.target.value.length === 0) {
    return;
  }

  if (event.timeStamp - eventTs.value < 20) {
    return;
  }
  eventTs.value = event.timeStamp;

  //  new
  const m = (event.target.value as string).match(regex);
  const inputDate = toDate(m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 0, 0, 0) : new Date(2001, 0, 1, 0, 0, 0)); //< 最後は起こりえない

  if (inputDate.getTime() === preDate.getTime()) return;

  if (editedMovement) {
    const res = await confirm(`${props.dataName}が保存されていません。保存せず日付を変更しますか？`, 'width: auto');
    if (!res) {
      date.value = preDate;
      return;
    }
  }

  date.value = inputDate;
  model.value = date.value;
}

function init() {
  setComponentModel();
}

init();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DateBox, {
    modelValue: date.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((date).value = $event)),
    onChange: _cache[1] || (_cache[1] = ($event: any) => (changeDate($event, props.edited, _unref(model)))),
    disabled: props.disabled,
    "min-date": props.minDate,
    "max-date": props.maxDate
  }, null, 8, ["modelValue", "disabled", "min-date", "max-date"]))
}
}

})